/* esm.sh - react-router@7.15.1/dom */
export * from "/*react-router@7.15.1/esnext/dom.mjs";
